<script setup lang="ts">
import {computed, type PropType} from "vue";
import PlaceUtils from "@/utils/common/PlaceUtils.ts";
import ApprovalUtils from "@/utils/editView/ApprovalUtils.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import DTOApprovalCase = namaTypes.DTOApprovalCase;

let props = defineProps({
  approval: {
    type: Object as PropType<DTOApprovalCase>,
    required: true
  }
})

const linkToApprovedElement = computed(() => PlaceUtils.linkToObject(props.approval.approvedElement!));

function approve() {
  ApprovalUtils.showApprovalDialog(props.approval)
}
</script>

<template>
  <div class="tw-group tw-w-full tw-flex tw-justify-between tw-border-b-[0.25px] tw-border-gray-300 tw-p-2.5
        hover:tw-bg-namaBackground-dim-light dark:hover:tw-bg-gray-700 hover:tw-border-primary-light first:hover:tw-rounded-t tw-gap-2">
    <div
      class="dark:tw-text-namaFontColor-input-dark tw-max-w-full tw-grow group-hover:tw-text-namaFontColor-input-light group-hover:dark:tw-text-namaFontColor-input-dark">
      <a class="tw-font-bold tw-cursor-pointer tw-m-0" v-text="approval.approvedElement?.code" :href="linkToApprovedElement"/>
      <div v-if="approval.summary" v-html="approval.summary" data-scrollbar-reveal class="tw-max-h-[calc(50vh-var(--navbar-height))]"/>
    </div>
    <div class="tw-shrink-0">
      <NamaIcon default-icon="nm-approve" class="tw-cursor-pointer" @click="approve"/>
    </div>
  </div>
</template>

<style scoped>

</style>
